import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 1.85a2.1 2.1 0 0 1 2.07 2.44l-.4 2.14h3.12a1.9 1.9 0 0 1 1.43.62 2.22 2.22 0 0 1 .52 1.7l-.41 4.71a2.09 2.09 0 0 1-2.09 1.89H5.436V6.43h.004L6 3.6a2 2 0 0 1 2-1.75Zm-3.702 13.5H2a.76.76 0 0 1-.75-.75V7.18A.76.76 0 0 1 2 6.43h2.298v8.92Z';
const draw24px =
  'M11.64 2.85a2.752 2.752 0 0 1 2.652 2.025c.105.386.124.79.058 1.185l-.47 2.79H19a2.47 2.47 0 0 1 1.85.81 2.906 2.906 0 0 1 .67 2.22l-.6 7a2.72 2.72 0 0 1-2.73 2.47H8.43V8.5L9 5.1a2.68 2.68 0 0 1 2.64-2.25Zm-4.71 18.5H3a.75.75 0 0 1-.75-.75v-11A.76.76 0 0 1 3 8.85h3.93v12.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ThumbsUpFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'thumbsUpFilledIcon')) as IconWithRender;

ThumbsUpFilledIcon.displayName = 'AccViewerIcon';
ThumbsUpFilledIcon.propTypes = Icon.propTypes;
ThumbsUpFilledIcon.renderIcon = (props) => <ThumbsUpFilledIcon {...props} />;
export default ThumbsUpFilledIcon;
